window.addEventListener('DOMContentLoaded',function(){
    jQuery('.range-slider').each(function(i){
        jQuery(this).ionRangeSlider({
            type: 'double',
            skin: 'sharp',
            grid: false,
            prettify_separator: ',',
            values_separator: ' to ',
            onStart: (e) => {
                const dollar = (this.name=='price')?'$':'';
                this.closest('.filter').dataset.from = e.from;
                this.closest('.filter').dataset.to = e.to;
                this.closest('.filter').querySelector('.sel').innerText = dollar + e.from_pretty + ' to ' + dollar + e.to_pretty;
                runfilters(this.closest('.wp-block-smarttouch-filters'), false);
            },
            onFinish: (e) => {
                const dollar = (this.name=='price')?'$':'';
                this.closest('.filter').dataset.from = e.from;
                this.closest('.filter').dataset.to = e.to;
                this.closest('.filter').querySelector('.sel').innerText = dollar + e.from_pretty + ' to ' + dollar + e.to_pretty;
                runfilters(this.closest('.wp-block-smarttouch-filters'), true);
            },
            onUpdate: (e) => {
                const dollar = (this.name=='price')?'$':'';
                this.closest('.filter').dataset.from = e.from;
                this.closest('.filter').dataset.to = e.to;
                this.closest('.filter').querySelector('.sel').innerText = dollar + e.from_pretty + ' to ' + dollar + e.to_pretty;
                runfilters(this.closest('.wp-block-smarttouch-filters'), true);
            }
        });
    });
    document.querySelectorAll('.wp-block-smarttouch-filters').forEach(filters=>{
        const type = filters.dataset.type;
        filters.querySelectorAll('.filter[data-value]').forEach(filter=>{
            const rel = filter.getAttribute('rel');
            filter.querySelectorAll('.option').forEach(option=>{
                option.onclick=(e)=>{
                    option.classList.toggle('is-checked');
                    updateFilterOptions(filter);
                    runfilters(filters,true);
                }
            });
            updateFilterOptions(filter);
        });
        filters.querySelectorAll('.filter').forEach(filter=>{
            filter.onclick = (e) => {
                filter.classList.toggle('active');
            };
        });        
        runfilters(filters,true);
    });
});
function updateFilterOptions(filter) {
    let checked = [];
    let label = '';
    filter.querySelectorAll('.option').forEach(option=>{
        if(option.classList.contains('is-checked')) {
            checked.push(option.getAttribute('rel'));
            label = option.innerText;
        }
    });
    if(checked.length==0) { filter.dataset.value = ''; filter.querySelector('.sel').innerHTML = 'Any'; }
    else if(checked.length==1) { filter.dataset.value = checked[0]; filter.querySelector('.sel').innerHTML = label; }
    else { filter.dataset.value = checked.join(','); filter.querySelector('.sel').innerHTML = checked.length + ' Selections'; }
}

window.resetFilters = () => {
    document.querySelectorAll('.wp-block-smarttouch-filters').forEach(filters=>{
        filters.querySelectorAll('.filter').forEach(filter=>{
            if(filter.dataset.value) filter.dataset.value = '';
            if(filter.dataset.from) {
                const range = filter.querySelector('.range-slider');
                jQuery(range).data('ionRangeSlider').update({
                    from: range.dataset.min,
                    to: range.dataset.max
                });
            }
            const checked = filter.querySelector('.is-checked');
            if(checked) {
                filter.querySelectorAll('.is-checked').forEach(checked=>{
                    checked.classList.remove('is-checked');
                });
                updateFilterOptions(filter);
            }
        });
        runfilters(filters,true);
    });
}
function runfilters(filters,animate) {
    animate = animate?1:0;
    const type = filters.dataset.type;
    document.querySelectorAll('.wp-block-smarttouch-homes .view-'+type+'.layout-grid').forEach(container=>{
        const cards = container.querySelectorAll('.'+type);
        const state = Flip.getState(cards);
        let filteredCount = 0;
        if(cards.length) {
            cards.forEach(card=>{
                let filtered = false;
                filters.querySelectorAll('.filter').forEach(filter=>{
                    const rel = filter.getAttribute('rel');
                    if(filter.dataset.value) {
                        let valueFilter = true;
                        if(rel=='other') {
                            valueFilter = false;
                            filter.dataset.value.split(',').forEach(v=>{
                                if(!v) return;
                                if(!String(card.dataset[rel]).includes(v)) valueFilter = true;
                            });
                        } else {
                            card.dataset[rel].split(',').forEach(v=>{
                                if(!v) return;
                                if(String(filter.dataset.value).includes(v)) valueFilter = false;
                            });
                        }
                        if(valueFilter) filtered = true;
                    } else {
                        if(+card.dataset[rel]<+filter.dataset.from) filtered = true;
                        if(+card.dataset[rel]>+filter.dataset.to) filtered = true;
                    }
                });
                if(filtered) { filteredCount++; card.classList.add('filtered'); } else { card.classList.remove('filtered'); }
            });
            if(filteredCount==cards.length) { container.classList.add('no-results'); } else { container.classList.remove('no-results'); } 
            Flip.from(state, {
                duration: animate,
                scale: true,
                absolute: '.filtered',
                ease: "power1.inOut",
                onEnter: elements => gsap.fromTo(elements, {opacity: 0, scale: 0}, {opacity: 1, scale: 1, duration: animate}),
                onLeave: elements => gsap.to(elements, {opacity: 0, scale: 0, duration: animate})
            });
        }
    });
}

export function processHomes(base = document) {
    base.querySelectorAll('.wp-block-smarttouch-homes').forEach((homes)=>{
        homes.querySelectorAll('.layout-carousel .swiper').forEach((s)=>{
            const rel = s.getAttribute('rel');
            if(s.querySelector('.swiper-wrapper').childElementCount) {
                const swiper = new Swiper(s,{
                    slidesPerView: 1,
                    spaceBetween: 20,
                    lazy: {
                        loadPrevNext: true
                    },
                    navigation: {
                        nextEl: '.swiper-button-next[rel="'+rel+'"]',
                        prevEl: '.swiper-button-prev[rel="'+rel+'"]',
                    },
                    breakpoints: {
                        480: { slidesPerView: 2 },
                        768: { slidesPerView: 3 }
                    }
                });
            } else {
                s.remove();
            } 
        });
        homes.querySelectorAll('.community-overview .swiper, .model-overview .swiper').forEach((s)=>{
            const swiper = new Swiper(s,{
                preloadImages: false,
                centerMode: true,
                loop: true,
                lazy: {
                    loadPrevNext: true
                },
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                }
            });
        });
        homes.querySelectorAll('.map').forEach((m)=>{
            const markers = JSON.parse(atob(m.dataset.markers));
            console.log(markers);
            var bounds = new google.maps.LatLngBounds();
            const map = new google.maps.Map(m, {});
            const infoWindow = new google.maps.InfoWindow({});
            markers.forEach(m=>{
                if(!m.location) return;
                const marker = new google.maps.Marker({
                    position: m.location,
                    title: m.title,
                    map
                });
                marker.addListener('click',()=>{
                    let content = '<h2>'+(m.title||m.name)+'</h2><div class="ctas">';
                    if(m.ctas) m.ctas.forEach(cta=>{ content += cta; });
                    content += '<a href="'+m.url+'" target="_blank" class="has-icon"><span class="icon"><svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.01 53.62"><path fill="currentColor" d="M37.52,19.51h1.5C39.01,8.73,30.28,0,19.51,0c-.71,0-1.43,.04-2.15,.12C8.71,1.05,1.61,7.81,.24,16.4,.08,17.45,0,18.49,0,19.51c0,3.55,.97,6.89,2.63,9.75l1.3-.75-.76-1.3h-.01c-.71,.42-.96,1.34-.54,2.05l12.65,21.91c.46,.8,1.12,1.43,1.86,1.84,.74,.41,1.57,.61,2.39,.61,.82,0,1.64-.2,2.39-.61,.74-.41,1.4-1.04,1.86-1.84l12.65-21.91c.41-.71,.17-1.63-.54-2.05h-.01s-.76,1.29-.76,1.29l1.3,.75c1.66-2.86,2.63-6.19,2.63-9.75h-3c0,3.01-.82,5.81-2.22,8.25-.41,.72-.17,1.63,.54,2.05h.01s.76-1.29,.76-1.29l-1.3-.75-12.65,21.91c-.19,.33-.44,.56-.72,.71-.28,.16-.6,.24-.93,.24-.33,0-.65-.08-.93-.24-.28-.16-.53-.38-.72-.71L5.21,27.76l-1.3,.75,.76,1.3h.01c.72-.42,.96-1.34,.54-2.05-1.41-2.43-2.22-5.24-2.22-8.25,0-.86,.07-1.74,.21-2.64,1.12-7.22,7.2-13,14.47-13.77,.62-.07,1.23-.1,1.83-.1,4.56,0,8.68,1.85,11.67,4.83,2.99,2.99,4.83,7.11,4.83,11.67h1.5Z" style="fill: currentColor;"></path><path fill="currentColor" d="M28.29,19.51h-1.5c0,2.02-.81,3.83-2.13,5.15-1.32,1.32-3.14,2.13-5.15,2.13-2.02,0-3.83-.81-5.15-2.13-1.32-1.32-2.13-3.13-2.13-5.15,0-2.02,.81-3.83,2.13-5.15,1.32-1.32,3.14-2.13,5.15-2.13,2.02,0,3.83,.81,5.15,2.13,1.32,1.32,2.13,3.14,2.13,5.15h3c0-5.68-4.6-10.29-10.29-10.29-5.68,0-10.29,4.6-10.29,10.29,0,5.68,4.6,10.28,10.29,10.29,5.68,0,10.28-4.6,10.29-10.29h-1.5Z" style="fill: currentColor;"></path></svg></span><span class="label">DRIVING DIRECTIONS</span></a></div>';
                    infoWindow.setContent(content);
                    infoWindow.open({ anchor: marker, map });
                });
                if(m.icon) marker.setIcon(m.icon);
                if(markers.length>1) { bounds.extend(m.location); } else { map.fitBounds(m.bounds,0); }
            });
            if(markers.length>1) map.fitBounds(bounds);
        });
    });
}